var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.handlerlist),function(b,bindex){return _c('el-button',{key:bindex,staticStyle:{"margin-left":"5px","margin-top":"5px"},attrs:{"size":"mini","type":b.type,"icon":b.icon},nativeOn:{"click":function($event){return _vm.handle(b)}}},[_vm._v(_vm._s(b.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }